export const categories = [
  { slug: "hanman", name: "韩漫", icon: "ri-global-line" },
  { slug: "riman", name: "日漫", icon: "ri-sun-line" },
  { slug: "guoman", name: "国漫", icon: "ri-flag-2-line" },
  { slug: "rexue", name: "热血", icon: "ri-fire-line" },
  { slug: "lianai", name: "恋爱", icon: "ri-heart-line" },
  { slug: "xuanyi", name: "悬疑", icon: "ri-search-eye-line" },
  { slug: "qihuan", name: "奇幻", icon: "ri-magic-line" },
  { slug: "gaoxiao", name: "搞笑", icon: "ri-emotion-laugh-line" },
  { slug: "dongzuo", name: "动作", icon: "ri-boxing-line" },
  { slug: "kehuan", name: "科幻", icon: "ri-rocket-line" },
  { slug: "kongbu", name: "恐怖", icon: "ri-ghost-line" },
  { slug: "danmei", name: "耽美", icon: "ri-star-line" },
];

export const comics = [
  {
    id: 1,
    title: "我独自升级",
    author: "Chugong / DUBU",
    category: "hanman",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20art%2C%20solo%20leveling%20theme%2C%20dark%20fantasy%20hunter%20with%20glowing%20blue%20eyes%2C%20mysterious%20dungeon%20background%2C%20dramatic%20lighting%2C%20anime%20art%20style%2C%20clean%20illustration%20with%20bold%20lines%2C%20professional%20manga%20cover%20quality&width=600&height=800&seq=comic-01&orientation=portrait",
    description: "十年前，世界各地出现了连接异次元的「传送门」，而觉醒了特殊能力的人们被称为「猎人」。身为最弱E级猎人的成振宇，在一次地下城探险中遭遇了生死危机，却意外获得了神秘系统的力量——「玩家」系统。从此，他成为了唯一能够「升级」的猎人，踏上了从最弱到最强的逆袭之路。",
    tags: ["热血", "奇幻", "系统流", "逆袭"],
    rating: 9.7,
    views: 12500000,
    chapters: 179,
    status: "已完结",
    updatedAt: "2024-12-20",
  },
  {
    id: 2,
    title: "神之塔",
    author: "SIU",
    category: "hanman",
    cover: "https://readdy.ai/api/search-image?query=Tower%20of%20God%20manhwa%20style%2C%20mysterious%20boy%20climbing%20a%20massive%20tower%2C%20dark%20fantasy%20atmosphere%2C%20colorful%20energy%20effects%2C%20anime%20art%20style%2C%20epic%20scale%2C%20professional%20illustration%2C%20clean%20manga%20cover&width=600&height=800&seq=comic-02&orientation=portrait",
    description: "只要登顶神之塔，任何愿望都能实现。少女蕾哈尔为了追寻星空离开了少年夜，而夜为了追寻蕾哈尔进入了神之塔。在这座充满试炼与背叛的巨塔中，夜逐渐揭开了关于自己身世的惊人秘密，也结识了一群值得信赖的伙伴。一场波澜壮阔的冒险就此展开。",
    tags: ["奇幻", "冒险", "友情", "战斗"],
    rating: 9.5,
    views: 9800000,
    chapters: 632,
    status: "连载中",
    updatedAt: "2025-01-15",
  },
  {
    id: 3,
    title: "咒术回战",
    author: "芥见下下",
    category: "riman",
    cover: "https://readdy.ai/api/search-image?query=Jujutsu%20Kaisen%20manga%20style%2C%20boy%20with%20spiky%20pink%20hair%20fighting%20cursed%20spirits%2C%20dark%20supernatural%20theme%2C%20dynamic%20action%20pose%2C%20Japanese%20anime%20art%20style%2C%20professional%20manga%20cover%2C%20clean%20illustration%20with%20energy%20effects&width=600&height=800&seq=comic-03&orientation=portrait",
    description: "拥有超越人类极限体能的高中生虎杖悠仁，原本过着普通的生活。某天为了解救被「咒灵」袭击的学长学姐，他吞下了宿傩的手指，成为了诅咒之王「两面宿傩」的容器。从此，虎杖被卷入咒术师与咒灵之间的战斗，进入了东京都立咒术高等专门学校。",
    tags: ["热血", "战斗", "超自然", "校园"],
    rating: 9.4,
    views: 15600000,
    chapters: 271,
    status: "已完结",
    updatedAt: "2024-09-30",
  },
  {
    id: 4,
    title: "间谍过家家",
    author: "远藤达哉",
    category: "riman",
    cover: "https://readdy.ai/api/search-image?query=Spy%20x%20Family%20manga%20style%2C%20family%20of%20three%20with%20spy%20dad%20and%20assassin%20mom%20and%20telepath%20daughter%2C%20warm%20comedy%20atmosphere%2C%20anime%20art%20style%2C%20professional%20illustration%2C%20clean%20manga%20cover%2C%20light%20color%20tone&width=600&height=800&seq=comic-04&orientation=portrait",
    description: "为了执行秘密任务，代号「黄昏」的西国顶级间谍需要在一周内组建一个临时家庭。他收养了能读心的超能力少女阿尼亚，并与身份为暗杀者的约尔小姐假结婚。三人各怀秘密却组成了一个温馨的家庭，由此展开了一系列搞笑又感人的日常与冒险。",
    tags: ["搞笑", "日常", "间谍", "亲情"],
    rating: 9.3,
    views: 11200000,
    chapters: 105,
    status: "连载中",
    updatedAt: "2025-02-28",
  },
  {
    id: 5,
    title: "全职高手",
    author: "蝴蝶蓝",
    category: "guoman",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20manhua%20style%2C%20esports%20player%20with%20gaming%20headset%2C%20cyberpunk%20gaming%20background%2C%20The%20Kings%20Avatar%20theme%2C%20cool%20male%20character%2C%20professional%20illustration%2C%20clean%20lines%2C%20anime%20art%20style&width=600&height=800&seq=comic-05&orientation=portrait",
    description: "荣耀职业联赛史上最强的选手叶修，因种种原因被俱乐部驱逐，流落到一家小网吧当网管。但他并未就此放弃，而是带着十年的游戏经验和无人能及的操作技术，重新投入游戏「荣耀」的世界中。从零开始，他手持自制武器「千机伞」，踏上了重返巅峰之路。",
    tags: ["电竞", "热血", "竞技", "逆袭"],
    rating: 9.6,
    views: 8900000,
    chapters: 186,
    status: "已完结",
    updatedAt: "2024-06-15",
  },
  {
    id: 6,
    title: "天官赐福",
    author: "墨香铜臭 / STARember",
    category: "guoman",
    cover: "https://readdy.ai/api/search-image?query=Heaven%20Officials%20Blessing%20Chinese%20manhua%20style%2C%20elegant%20male%20character%20in%20flowing%20white%20robe%2C%20soft%20pastel%20colors%2C%20ancient%20Chinese%20fantasy%20aesthetic%2C%20beautiful%20illustration%2C%20refined%20art%20style%2C%20butterfly%20motif%2C%20professional%20cover&width=600&height=800&seq=comic-06&orientation=portrait",
    description: "八百年前，谢怜贵为仙乐国太子，风光无限地飞升成仙。然而好景不长，他接连被贬下凡，成为了三界笑柄。八百年后，谢怜第三次飞升，却意外破坏了各路神官的灵验殿。为了偿还债务，他不得不下凡处理各种委托，并遇到了那个等了他八百年的鬼王花城。",
    tags: ["古风", "仙侠", "耽美", "奇幻"],
    rating: 9.8,
    views: 10200000,
    chapters: 132,
    status: "连载中",
    updatedAt: "2025-03-10",
  },
  {
    id: 7,
    title: "鬼灭之刃",
    author: "吾峠呼世晴",
    category: "riman",
    cover: "https://readdy.ai/api/search-image?query=Demon%20Slayer%20manga%20style%2C%20boy%20with%20green%20checkered%20haori%20holding%20katana%2C%20water%20breathing%20effects%2C%20dark%20demon%20background%2C%20Japanese%20anime%20art%20style%2C%20professional%20manga%20cover%2C%20dramatic%20composition&width=600&height=800&seq=comic-07&orientation=portrait",
    description: "大正时代的日本，少年灶门炭治郎一家被鬼袭击，仅存的妹妹祢豆子却变成了鬼。为了寻找让妹妹恢复成人类的方法，炭治郎踏上了成为鬼杀队剑士的道路。在修行与战斗中，他逐渐揭开了鬼舞辻无惨的千年阴谋，也收获了珍贵的伙伴情谊。",
    tags: ["热血", "战斗", "和风", "亲情"],
    rating: 9.5,
    views: 18300000,
    chapters: 205,
    status: "已完结",
    updatedAt: "2024-03-20",
  },
  {
    id: 8,
    title: "某天成为公主",
    author: "Plutus / Spoon",
    category: "hanman",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20style%2C%20beautiful%20princess%20with%20blonde%20hair%20in%20elegant%20dress%2C%20fantasy%20royal%20palace%20background%2C%20soft%20pastel%20colors%2C%20shoujo%20art%20style%2C%20professional%20illustration%2C%20romantic%20fairytale%20atmosphere&width=600&height=800&seq=comic-08&orientation=portrait",
    description: "一觉醒来，我竟然变成了小说中注定要死去的悲催公主阿西娅！按照原著剧情，我将在18岁生日那天被亲生父亲——冷血皇帝克劳德处死。为了活下来，我决定从现在开始疯狂讨好父皇。但不知道为什么，原本冷酷无情的父皇，看我的眼神越来越温柔了……",
    tags: ["恋爱", "奇幻", "穿越", "亲情"],
    rating: 9.4,
    views: 7600000,
    chapters: 137,
    status: "已完结",
    updatedAt: "2024-11-05",
  },
  {
    id: 9,
    title: "完美世界",
    author: "辰东",
    category: "guoman",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20manhua%20cultivation%20style%2C%20young%20warrior%20in%20ancient%20Chinese%20armor%2C%20powerful%20energy%20aura%2C%20mystical%20Eastern%20fantasy%20background%2C%20professional%20illustration%2C%20bold%20dynamic%20composition%2C%20martial%20arts%20theme&width=600&height=800&seq=comic-09&orientation=portrait",
    description: "一粒尘可填海，一根草斩尽日月星辰，弹指间天翻地覆。群雄并起，万族林立，诸圣争霸，乱天动地。一个少年从大荒中走出，身负至尊骨，手持至尊神兵，自下界一步步走向上界，历经千难万险，最终成就无敌传说。问苍茫大地，谁主沉浮？",
    tags: ["玄幻", "修仙", "热血", "战斗"],
    rating: 9.2,
    views: 14500000,
    chapters: 358,
    status: "连载中",
    updatedAt: "2025-02-20",
  },
  {
    id: 10,
    title: "电锯人",
    author: "藤本树",
    category: "riman",
    cover: "https://readdy.ai/api/search-image?query=Chainsaw%20Man%20manga%20style%2C%20boy%20with%20chainsaw%20head%20and%20arms%20in%20action%20pose%2C%20dark%20urban%20background%2C%20blood%20red%20color%20scheme%2C%20Japanese%20anime%20art%20style%2C%20punk%20aesthetic%2C%20professional%20illustration%2C%20bold%20graphic%20style&width=600&height=800&seq=comic-10&orientation=portrait",
    description: "背负着父亲遗留的巨额债务，少年淀治与恶魔「波奇塔」一起靠斩杀恶魔勉强维生。某天，淀治被信任的人背叛杀害，在濒死之际，波奇塔与他合为一体，使他获得了变身为「电锯人」的能力。随后，淀治被公安对魔特异4课收编，开始了作为恶魔猎人的全新生活。",
    tags: ["热血", "黑暗", "战斗", "都市"],
    rating: 9.1,
    views: 13400000,
    chapters: 197,
    status: "连载中",
    updatedAt: "2025-01-25",
  },
  {
    id: 11,
    title: "黑执事",
    author: "枢梁",
    category: "riman",
    cover: "https://readdy.ai/api/search-image?query=Black%20Butler%20manga%20style%2C%20elegant%20butler%20in%20black%20suit%20with%20young%20master%2C%20Victorian%20gothic%20atmosphere%2C%20dark%20supernatural%20theme%2C%20Japanese%20anime%20art%20style%2C%20refined%20illustration%2C%20professional%20manga%20cover&width=600&height=800&seq=comic-11&orientation=portrait",
    description: "19世纪的英国，名门贵族凡多姆海伍家的少爷夏尔年仅12岁便继承了家业，经营着庞大的玩具制造公司，同时也在暗中为女王执行各种秘密任务。而他身边那位万能的管家——塞巴斯蒂安·米卡利斯，实际上是与夏尔缔结了契约的恶魔，只为在任务完成后享用他美味的灵魂。",
    tags: ["悬疑", "奇幻", "哥特", "主仆"],
    rating: 9.3,
    views: 8700000,
    chapters: 210,
    status: "连载中",
    updatedAt: "2025-03-01",
  },
  {
    id: 12,
    title: "国民死刑投票",
    author: "严世贤 / 郑惠珍",
    category: "hanman",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20thriller%20style%2C%20mysterious%20masked%20figure%20with%20voting%20theme%2C%20dark%20urban%20crime%20scene%2C%20suspenseful%20atmosphere%2C%20professional%20illustration%2C%20bold%20contrast%20lighting%2C%20thriller%20genre%20cover&width=600&height=800&seq=comic-12&orientation=portrait",
    description: "一个名为「狗头」的神秘人突然出现，向全体国民发出了一条消息：他将对罪大恶极却逃脱法律制裁的罪犯执行死刑，而是否执行，将由全体国民通过手机投票决定。赞成票超过半数，死刑立即执行。当法律无法伸张正义时，你会按下赞成还是反对？",
    tags: ["悬疑", "犯罪", "社会", "惊悚"],
    rating: 9.0,
    views: 6200000,
    chapters: 88,
    status: "连载中",
    updatedAt: "2025-02-10",
  },
];

export const featuredComics = [1, 5, 3, 2, 6];

export const hotComics = [3, 7, 5, 1, 9, 6, 10, 4, 2, 11, 8, 12];

export const latestUpdates = [
  { comicId: 6, chapter: "第132话", title: "花开彼岸", date: "2025-03-10" },
  { comicId: 11, chapter: "第210话", title: "恶魔的低语", date: "2025-03-01" },
  { comicId: 4, chapter: "第105话", title: "家庭旅行大作战", date: "2025-02-28" },
  { comicId: 9, chapter: "第358话", title: "巅峰对决", date: "2025-02-20" },
  { comicId: 12, chapter: "第88话", title: "最后的审判", date: "2025-02-10" },
  { comicId: 2, chapter: "第632话", title: "塔顶的真相", date: "2025-01-15" },
  { comicId: 10, chapter: "第197话", title: "新生", date: "2025-01-25" },
  { comicId: 8, chapter: "第137话", title: "温暖的拥抱", date: "2024-11-05" },
  { comicId: 5, chapter: "第186话", title: "荣耀之巅", date: "2024-06-15" },
  { comicId: 3, chapter: "第271话", title: "终焉", date: "2024-09-30" },
];

export const rankings = {
  popularity: [3, 7, 5, 1, 10, 9, 6, 4, 2, 11],
  rating: [6, 1, 7, 3, 2, 8, 4, 11, 5, 9],
  trending: [4, 12, 6, 2, 9, 10, 1, 11, 7, 3],
};